<template>
  <div>
    <h1 v-if="this.$route.params.id">Modificación a tarifa de tipo de vehículo</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <!--
            <div class="col-md-3">
              <label>Foto</label>
                <base-image-input v-model="$v.imageData.$model" :imagen="getVehicleTypeById.imageVehicle"/>
                <small class="text-danger" v-if="!$v.imageData.required">Campo requerido</small>
                <br>
            </div>
            -->
            <!--
            <div class="col-md-6" v-if="camposOcultos">
              <a-form-item label="Charge Discount">
                <a-input
                  placeholder="Charge Discount"
                  v-model="$v.getVehicleTypeById.chargeDiscount.$model"
                />
                <small class="text-danger" v-if="!$v.getVehicleTypeById.chargeDiscount.required">Campo requerido</small>
              </a-form-item>
            </div>
            -->
            <div class="col-md-6">
              <a-form-item label="Tipo de vehículo">
                <a-input
                  placeholder="Tipo de vehículo"
                  v-model="$v.getVehicleTypeById.type.$model"
                  :disabled="true"
                />
                <small class="text-danger" v-if="!$v.getVehicleTypeById.type.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Porcentaje de comisión por tipo de vehículo">
                <!--
                <a-input
                  placeholder="Tarifa"
                  v-model="$v.getVehicleTypeById.fare.$model"
                />-->
                <b-form-input size="sm" v-model="$v.getVehicleTypeById.fare.$model" type="number" ></b-form-input>
                <small class="text-danger" v-if="!$v.getVehicleTypeById.fare.required">Campo requerido</small>
                <small class="text-danger" v-if="!$v.getVehicleTypeById.fare.maxValue">Ingresa una tarifa menor o igual a 100</small>
                <small class="text-danger" v-if="!$v.getVehicleTypeById.fare.minValue">Ingresa una tarifa mayor o igual a 0</small>
                <small class="text-danger" v-if="!$v.getVehicleTypeById.fare.integer">Ingresa un valor entero</small>
              </a-form-item>
            </div>
            <!--{{ !(!$v.imageData.required && !$v.getVehicleTypeById.fare.required && !$v.getVehicleTypeById.fare.maxValue && !$v.getVehicleTypeById.fare.minValue && !$v.getVehicleTypeById.fare.integer && !$v.getVehicleTypeById.type.required) }}-->
            <div class="col-12">
              <a-form-item>
                <button
                  :disabled="$v.$invalid"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, maxValue, minValue, integer } from 'vuelidate/lib/validators'
// import { uploadFileS3 } from '../../../s3/s3Up'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
// import BaseImageInput from '@/components/imageInput'
// import { encrypt } from '@/config/headers'
export default {
  data() {
    return {
      camposOcultos: false,
      disabledButton: false,
      error: null,
      form: this.$form.createForm(this),
      id: this.$route.params.id,
      getVehicleTypeById: {
        chargeDiscount: null,
        fare: this.$route.params.fare * 100,
        type: this.$route.params.type,
      },
      imageData: this.$route.params.imageVehicle,
      objectFile: [],
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
    }
  },
  components: {
    // BaseImageInput,
  },
  /*
  apollo: {
    getVehicleTypeById: {
      query: gql`
        query getVehicleTypeById($id: Int!) {
          getVehicleTypeById(id: $id) {
            id
            chargeDiscount
            fare
            type
            imageVehicle
          }
        }
      `,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      error (erro) {
        console.log(erro)
      },
      result ({ data }) {
        this.getVehicleTypeById.fare = data.getVehicleTypeById.fare * 100
      },
      variables() {
        return {
          id: parseInt(this.id),
        }
      },
      skip() {
        return this.skipQuery
      },
    },
  }, */
  created() {
    // console.log(this.$route.params)
    /*
    if (this.$route.params.id != null) {
      this.$apollo.queries.getVehicleTypeById.skip = false
    } */
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault()
      /*
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      if (typeof (this.imageData) === 'object') {
        this.objectFile.fileExtension = this.imageData.name.split('.').pop()
        this.objectFile.fileUploaded = this.imageData
        const data = await uploadFileS3(this.objectFile)
        this.imageLoadData = data.Location
        // console.log(this.imageLoadData)
        // console.log(this.imageData)
        // return
      } else {
        this.imageLoadData = this.imageData
      }
      this.disabledButton = true
      */
      // if (this.id != null) {
      await this.$apollo.mutate({
        mutation: gql`mutation updatevehicleType($idEdit: Int, $chargeDiscount: String, $fare: Float, $type: String, $imageVehicle: String) {
        updatevehicleType(id: $idEdit, vehicleType: {
                chargeDiscount:$chargeDiscount
                fare:$fare
                type:$type
                imageVehicle: $imageVehicle
            }){
                chargeDiscount
                fare
                type
                imageVehicle
            }
        }`,
        context: headers(),
        variables: {
          idEdit: parseInt(this.id),
          chargeDiscount: '', // this.getVehicleTypeById.chargeDiscount,
          fare: parseFloat(this.getVehicleTypeById.fare) / 100, // parseFloat(this.getVehicleTypeById.fare),
          type: this.getVehicleTypeById.type,
          imageVehicle: this.imageData,
        },
      })
        .then(res => {
          this.$router.push('/montos/TarifasTipoVehiculo')
        })
        .catch(error => {
          console.log(error)
          this.disabledButton = false
          this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
          this.mensaje.color = 'warning'
          this.showAlert()
        })
      /*
      } else {
        await this.$apollo.mutate({
          mutation: gql`mutation ($chargeDiscount: String, $fare: Float, $type: String, $imageVehicle: String) {
          createVehicleType(vehicleType: {
                  chargeDiscount:$chargeDiscount
                  fare:$fare
                  type:$type
                  imageVehicle: $imageVehicle
              }){
                  chargeDiscount
                  fare
                  type
                  imageVehicle
              }
          }`,
          context: {
            // headers: encrypt(new Date().getTime()),
          },
          variables: {
            chargeDiscount: '', // this.getVehicleTypeById.chargeDiscount,
            fare: this.getVehicleTypeById.fare / 100, // parseFloat(this.getVehicleTypeById.fare),
            type: this.getVehicleTypeById.type,
            imageVehicle: this.imageLoadData,
          },
        })
          .then(res => {
            this.$router.push('/vehiculos/getVehiclesTypes')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error)
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      }
      */
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
  validations: {
    imageData: { required },
    getVehicleTypeById: {
      // chargeDiscount: { required },
      fare: { required, maxValue: maxValue(100), minValue: minValue(0), integer },
      type: { required },
    },
  },
}
</script>

<style>

</style>
